import type { DocEntityType } from "building-types/doc/docEntityTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { snakeCaseToTitleCase } from "common/utils/strings";

export const docEntityFallbackNames: { [key in DocEntityType]?: string } = {
  PLAN_SET_TEMPLATE_CONFIG: "Untitled Plan Set Template Instance",
} as const;

export function docEntityFallbackName(handle?: DocEntityHandle): string {
  if (!handle) {
    return "Untitled Entity";
  }
  return docEntityFallbackNames[handle.type] || `Untitled ${snakeCaseToTitleCase(handle.type)}`;
}
